/**
 * Message d'erreur tel que le back l'a formule, extrait de ce qui a ete jete par la couche HTTP.
 *
 * Le back repond `{ code, message }` sur ses refus metier - « Code pays emetteur invalide:
 * Cote d'Ivoire » dit exactement quoi corriger. Sur un statut non-2xx la couche HTTP jette un objet
 * qui n'est pas une `Error` : `error.message` est vide et le code appelant retombait sur un
 * « une erreur est survenue » generique. L'agent voyait donc un echec sans cause, alors que la cause
 * etait dans la reponse.
 *
 * Ce depliage etait recopie dans cinq ecrans (`(exception.body as { message?: string })?.message`).
 * Il est ecrit une seule fois ici.
 */
export function backendMessage(error: unknown): string | null {
  if (!error || typeof error !== "object") {
    return null;
  }

  const candidate = error as {
    body?: unknown;
    message?: unknown;
    exception?: { body?: unknown };
  };

  // Corps de la reponse, ou le back place son message metier.
  const body = candidate.body ?? candidate.exception?.body;
  if (body && typeof body === "object") {
    const bodyMessage = (body as { message?: unknown }).message;
    if (typeof bodyMessage === "string" && bodyMessage.trim().length > 0) {
      return bodyMessage;
    }
  }

  // Repli : une vraie `Error`, ou un objet qui porte deja son message a plat.
  if (typeof candidate.message === "string" && candidate.message.trim().length > 0) {
    return candidate.message;
  }

  return null;
}
